/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Field, Form, Formik } from "formik";
import { bool, func, number } from "prop-types";
import { actions as comexActions } from "reducers/comex";
import { Col, Row } from "react-bootstrap";
import Button from "pages/_components/Button";
import FieldLabel from "pages/_components/fields/FieldLabel";
import GridTable from "pages/_components/GridTable/GridTable";
import * as configUtils from "util/config";
import { push } from "connected-react-router";
import DocumentUploader from "../_components/DocumentUploader";

// eslint-disable-next-line arrow-body-style
const FileTab = ({ isDesktop, handleSubmit }) => {
    const dispatch = useDispatch();

    const FORM_ID = "comex.clearance";
    const codeClearance = configUtils.get("comex.thuban.code.clearance", 1);
    const { comexTransfer = {}, comexDocumentation = {}, comexId = null } = useSelector((state) => state.comex);

    const initialValues = {
        clearance:  comexTransfer?.clearancesData?.data?.clearance ?? "",
        clearanceName: comexTransfer?.clearancesData?.data?.clearanceName ?? "",
    };

    const [formValues, setFormValues] = useState(initialValues);

    useEffect(() => {
        dispatch(
            comexActions.setComexDocument({
                ...comexDocumentation,
                ...formValues,
            }),
        );

        const data = {
            type: "file",
            data: formValues,
        };

        handleSubmit(data);
    }, [formValues]);

    const handleClickDownloadPDF = (filename) => {
        const link = document.createElement("a");
        link.href = `/templates/${filename}.xlsx`;
        link.download = `/templates/${filename}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

      const handleContinue = (values) => {
        let _comexRequest = {
            ...comexTransfer,
            clearancesData:  {
                type: "file",
                data: values,
            },
            comexId,
        };
        dispatch(comexActions.setComexTransfer(_comexRequest));
        dispatch(push("/comex/goods/paymentdata"));
    };


    return (
        <div className="container">
            <Row className="form-actions no-print">
                <Col xs={12} md={4} mdOffset={2}>
                    <Button
                        className="btn-outline"
                        image="images/figma/icon/download.svg"
                        label={`${FORM_ID}.example.template.label`}
                        onClick={() => handleClickDownloadPDF("Detalle_de_Despachos_PLANILLA")}
                    />
                </Col>
                <Col xs={12} md={4}>
                    <Button
                        className="btn btn-primary"
                        image="images/figma/icon/nuevo.svg"
                        onClick={() => handleClickDownloadPDF("Detalle_de_Despachos_ARCHIVO")}
                        label={`${FORM_ID}.file.template.label`}
                    />
                </Col>
            </Row>
            <Formik initialValues={initialValues} onSubmit={handleContinue}>
                {({ values }) => {
                    const canSubmit = !values.clearanceName || !values.clearance;
                    setFormValues(values);
                    return (
                        <>
                            <Form>
                                <GridTable className="form">
                                    <GridTable.Container columns={12} columnsTemplate="fixed">
                                        <GridTable.Data columnStart={2} columnWidth={10} className="form-group">
                                            <FieldLabel labelKey="massive.echeck.file" />
                                        </GridTable.Data>
                                        <GridTable.Data columnStart={2} flexDirection="column" columnWidth={10}>
                                            <Field
                                                component={DocumentUploader}
                                                idForm={FORM_ID}
                                                name="clearance"
                                                label={`${FORM_ID}.file.upload.input.label`}
                                                allowedTypes="xlsx"
                                                documentCode={codeClearance}
                                                defaultDocument={{
                                                    documentId: comexTransfer?.clearancesData?.data?.clearance,
                                                    documentName: comexTransfer?.clearancesData?.data?.clearanceName,
                                                }}
                                                withDocumentName
                                                overrideDocumentName="Despachos"
                                            />
                                        </GridTable.Data>
                                    </GridTable.Container>
                                </GridTable>
                                <Row className="form-actions">
                                    <Col xs={12} md={4} mdOffset={4}>
                                        <Button
                                            type="submit"
                                            className="btn-primary"
                                            label="global.continue"
                                            disabled={canSubmit}
                                        />
                                    </Col>
                                </Row>
                            </Form>
                        </>
                    );
                }}
            </Formik>
        </div>
    );
};

FileTab.propTypes = {
    isDesktop: bool.isRequired,
    handleSubmit: func.isRequired,
};

export default FileTab;
